
import React from "react";

function DynamicSelector({onSelect, defaultText, options}) {
    //console.log("Selector")

    
    
    const handleChange = (event) =>{
        onSelect(event.target.value);

    }

    return(
        <div>
            <select defaultValue={'DEFAULT'}  aria-label=".form-select-lg example" onChange = {handleChange}>
                <option value="DEFAULT" disabled >{defaultText}</option>
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                    {option.label}
                    </option>
                ))}
            </select>
        </div>
      

    );
}

export default DynamicSelector;